export enum Page {
  LOG_IN = '/log-in',
  CREATE_INSPECTION = '/create-inspection',
  VIDEO_CAPTURE = '/video-capture',
  INSPECTION_COMPLETE = '/inspection-complete',
}
